import { useEffect } from 'react'
import { useMapStore } from '../../store/mapStore'

// Keep the store's viewport slice in sync with the camera (on moveend, already
// debounced by MapLibre) so bookmarks / share-links can read the current view.
// Also consumes `flyTo` targets (bookmark / shared-link restore) and clears them.
export function useViewport(map) {
  useEffect(() => {
    if (!map.current) return
    const sync = () => {
      const c = map.current.getCenter()
      useMapStore.setState({
        viewport: {
          center: [+c.lng.toFixed(5), +c.lat.toFixed(5)],
          zoom: +map.current.getZoom().toFixed(3),
          bearing: +map.current.getBearing().toFixed(2),
        },
      })
    }
    map.current.on('moveend', sync)
    sync()
    return () => { map.current?.off('moveend', sync) }
  }, [map])

  // Apply flyTo targets pushed into the store.
  const flyTo = useMapStore((s) => s.flyTo)
  useEffect(() => {
    if (!flyTo || !map.current) return
    map.current.flyTo({
      center: flyTo.center,
      zoom: flyTo.zoom,
      bearing: flyTo.bearing || 0,
      duration: 1200,
    })
    useMapStore.setState({ flyTo: null })
  }, [flyTo, map])
}
